import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _path;
import { memo, useCallback, useState } from 'react';
import cn from 'clsx';
import { AnimatedStaticCoinRive } from "../../../AnimatedStaticCoinRive";
import BadgeDiamondStyles from "./BadgeDiamondStyles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var BadgeDiamond = function BadgeDiamond(_ref) {
  var diamonds = _ref.diamonds,
    completed = _ref.completed,
    animations = _ref.animations,
    className = _ref.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlayingCoin = _useState2[0],
    setIsPlayingCoin = _useState2[1];
  var handleCoinAnimation = useCallback(function (isPlaying) {
    return function () {
      return completed && setIsPlayingCoin(isPlaying);
    };
  }, [completed]);
  return /*#__PURE__*/_jsxs(BadgeDiamondStyles, {
    onMouseOver: handleCoinAnimation(true),
    onMouseLeave: handleCoinAnimation(false),
    className: cn(
    // Font
    'tw-font-subtitle4', completed ? 'tw-text-warning-500 dark:tw-text-warning-400 tw-text-center' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-700 tw-grayscale',
    // Dimensions
    'tw-w-6.4 tw-h-3.2',
    // Transitions
    'tw-transition tw-duration-1000 tw-ease-in',
    // Transform Y axis -50%
    'tw-translate-y-[-50%]',
    // Animation: customBadgeFadeIn 600ms ease forwards
    'tw-animate-[customBadgeFadeIn_600ms_ease_forwards]',
    // Opacity: Initial value, when executed the animation, it will be overwritten
    'tw-opacity-0',
    // Positioning
    'tw-absolute tw-right-0 tw-top-0 tw-mr-2.4', className),
    style: {
      animationDelay: "calc(100ms * ".concat((animations === null || animations === void 0 ? void 0 : animations.order) || 0, ")")
    },
    children: [/*#__PURE__*/_jsx("svg", {
      width: "65",
      height: "42",
      viewBox: "0 0 65 42",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-hidden": true,
      className: cn('tw-fill-current',
      // Drop shadow
      completed && 'tw-drop-shadow-sm dark:tw-drop-shadow-none', completed ? 'tw-text-warning-200' : 'tw-text-neutral-light-500 dark:tw-text-neutral-dark-600'),
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        d: "M0 0H65V37.0668C65 39.6086 62.6602 41.5057 60.1733 40.9804L34.1535 35.4839C33.0632 35.2536 31.9368 35.2536 30.8465 35.4839L4.82673 40.9804C2.3398 41.5057 0 39.6086 0 37.0668V0Z"
      }))
    }), /*#__PURE__*/_jsxs("div", {
      className: "tw-absolute tw-left-0 tw-top-0 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-3.6",
      children: [/*#__PURE__*/_jsx(AnimatedStaticCoinRive, {
        startAnimation: isPlayingCoin,
        disableAnimation: !completed
      }), /*#__PURE__*/_jsx("span", {
        className: "tw-ml-0.4 tw-font-subtitle4",
        children: diamonds
      })]
    })]
  });
};
export default /*#__PURE__*/memo(BadgeDiamond);